import NumericInput from '@/components/forms/components/numericInput';
import { useDynamicProps } from '@/hooks/useDynamicProps';
import { usePropsSynchronization } from '@/hooks/usePropsSynchronization';
import type { WidgetWriterProps } from '../widget.type';

export const NumericInputWidget = (rjsfProps: WidgetWriterProps) => {
  const handleChange = value => {
    props.onChange(value !== null ? value : '');
  };

  const props = useDynamicProps(rjsfProps);
  usePropsSynchronization(props, rjsfProps, handleChange);

  return (
    <NumericInput
      autoFocus={props.autoFocus}
      disabled={props.disabled}
      id={props.id}
      onBlur={e => props.onBlur(props.id, e.target.value)}
      onChange={handleChange}
      onFocus={e => props.onFocus(props.id, e.target.value)}
      placeholder={props.placeholder || 'Aa'}
      readOnly={props.readOnly}
      value={props.value || ''}
    />
  );
};
